import React from "react";
import BasicInformationView from "./view";

const BasicInformationPage = () => {
  return <BasicInformationView />;
};

export default BasicInformationPage;